import * as React from "react";

const SvgComponent = (props) => (
  <svg width="52" height="47" viewBox="0 0 52 47" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M18.63 17.4979C21.4811 15.2638 21.4811 10.9521 18.63 8.71795L9.03679 1.2005C5.3701 -1.67279 9.19305e-07 0.935949 7.01983e-07 5.59049L0 20.6254C-2.17322e-07 25.2799 5.37009 27.8887 9.03679 25.0154L18.63 17.4979ZM15.5032 15.4691C17.0407 14.2804 17.0407 11.962 15.5032 10.7733L8.21866 5.1415C6.26473 3.63087 3.42544 5.02167 3.42544 7.4894L3.42544 18.753C3.42544 21.2207 6.26473 22.6115 8.21866 21.1009L15.5032 15.4691Z"
      fill="#12B5EC"
    />
    <path
      d="M30.7914 10.1917C31.0285 9.99313 31.2481 9.7824 31.4503 9.56126L40.9044 1.64707C45.301 -2.0334 52 1.08831 52 6.81757V20.2285C52 20.7575 50.9819 21.0257 50.6181 20.6413C48.3213 18.2139 44.3019 17.597 41.3326 20.0827L21.4007 36.7681C21.3223 36.8337 21.2458 36.9007 21.1712 36.9689L11.0956 45.4034C6.69901 49.0839 -2.50766e-07 45.9622 0 40.2329L5.79519e-07 26.9927C6.02e-07 26.4791 0.889551 26.2333 1.2431 26.6063C3.54071 29.0303 7.55763 29.645 10.5252 27.1603L30.7914 10.1917Z"
      fill="#12B5EC"
    />
    <path
      d="M45.6011 21.1058C42.0671 21.1058 39.2022 23.9669 39.2022 27.4962V40.6096C39.2022 44.1389 42.0671 47 45.6011 47C49.1351 47 52 44.1389 52 40.6096V27.4962C52 23.9669 49.1351 21.1058 45.6011 21.1058Z"
      fill="#12B5EC"
    />
  </svg>
);

export default SvgComponent;
